class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.headerWrapper = document.querySelector('.header-wrapper--cuore-transparent');
    this._closeTimer = null;

    this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
    this.addEventListener('mouseleave', this.onMouseLeave.bind(this));

    // Also watch the floating panel — it's absolutely positioned outside
    // the header-menu layout box so the gap between the nav item and the
    // panel can trigger mouseleave before the user reaches the panel.
    const panel = this.querySelector('.mega-menu__content');
    if (panel) {
      panel.addEventListener('mouseenter', () => {
        if (window.innerWidth < 990) return;
        clearTimeout(this._closeTimer);
      });
      panel.addEventListener('mouseleave', () => {
        if (window.innerWidth < 990) return;
        this._scheduleClose();
      });
    }
  }

  onMouseEnter() {
    if (window.innerWidth < 990) return;
    clearTimeout(this._closeTimer);
    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', 'true');
    if (this.headerWrapper) this.headerWrapper.classList.add('header--scrolled');
  }

  onMouseLeave() {
    if (window.innerWidth < 990) return;
    this._scheduleClose();
  }

  _scheduleClose() {
    this._closeTimer = setTimeout(() => {
      this.close();
      if (this.headerWrapper) {
        // Only remove scrolled if we're actually at the top (not scrolled)
        if ((window.pageYOffset || document.documentElement.scrollTop) <= 30) {
          this.headerWrapper.classList.remove('header--scrolled');
        }
      }
    }, 120);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
